import { OffersBackToPdpBtnComponent } from './offers-back-to-pdp-btn.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ OffersBackToPdpBtnComponent });
